import hydrate from '../common/hydrate';
import CommonVisualNavigation from './components/CommonVisualNavigation';
import { root, name } from './manifest.json';
hydrate(CommonVisualNavigation, root, name);
if (module.hot) {
    module.hot.accept();
}
